module.exports = __webpack_public_path__ + "img/Shaman-troll-f-60.cceb6b09.gif";